import React from 'react';
import PropTypes from 'prop-types';
import emptyAnswer from 'config/emptyAnswer';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import RespondentInfoQuestionForm from '../RespondentInfoQuestionForm';
import { questionLayoutPropType } from '../../../config/richTextConfig/questionLayout';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const RespondentInfoQuestion = ({
  block: { clientUuid },
  block,
  answer = emptyAnswer,
  onAnswer,
  layout,
  e2e,
  styling,
  isCloned,
}) => (
  <RespondentInfoQuestionForm
    layout={layout}
    form={generateQuestionFormName(clientUuid, isCloned)}
    block={block}
    onSubmit={onAnswer}
    initialValues={answer}
    e2e={e2e}
    styling={styling}
  />
);

RespondentInfoQuestion.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
  }).isRequired,
  isCloned: PropTypes.bool,
  layout: questionLayoutPropType,
  onAnswer: PropTypes.func.isRequired,
  e2e: PropTypes.string,
  answer: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  styling: propTypeBlockStyling,
};

export default RespondentInfoQuestion;
